import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 200,
	viewBox: "0 0 200 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M127.338 128.107C124.811 124.639 122.209 121.15 119.811 117.764L119.688 117.593V117.559V117.497H119.579H119.007L117.944 117.422C117.263 117.374 116.677 117.313 116.159 117.244C115.443 117.179 114.74 117.015 114.068 116.759C113.387 116.396 114.115 115.993 116.609 115.698C117.372 115.609 118.469 115.548 119.504 115.5H120.724L122.372 117.607L123.687 119.324C124.552 120.48 125.39 121.649 126.194 122.812C127.774 125.111 129.423 127.395 131.106 129.652L136.89 137.348L138 138.825L118.292 138.887C110.587 138.887 102.936 138.887 95.2517 138.976C91.0688 139.03 86.7429 138.976 82.4851 138.976L62 138.9L65.924 133.681C68.1585 130.72 70.3998 127.771 72.6411 124.871L75.9996 120.555L79.5149 116.129L79.6034 116.013L81.5723 116.061C82.1241 116.061 82.6214 116.061 82.9347 116.136C83.7999 116.246 84.4607 116.417 84.4812 116.56C83.8635 116.752 83.2203 116.849 82.5737 116.848C82.199 116.848 81.763 116.895 81.3066 116.902H80.0463L79.7806 117.265L64.8476 137.355L73.9218 137.286L130.2 136.78H133.115H133.797H133.919L133.817 136.664L133.763 136.595L133.272 135.952L131.31 133.367L127.338 128.107Z",
				fill: "#212120"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M100 127.5L74 124.138L79.8369 116.356L89.315 115.5C89.315 115.5 98.8613 125.775 100 127.5Z",
				fill: "#212120"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M74.8002 98.7076L98.5184 127.063C99.0069 127.646 99.9928 127.646 100.481 127.063L124.199 98.7076C124.52 98.3248 124.591 97.7887 124.38 97.3337C124.17 96.88 123.716 96.5887 123.219 96.5887H112.339L106.956 64.114C106.62 62.0879 104.756 60.5 102.709 60.5H96.2928C94.2479 60.5 92.3825 62.0866 92.0453 64.114L86.6632 96.5887H75.7823C75.2836 96.5887 74.831 96.88 74.6207 97.3337C74.4092 97.7887 74.4797 98.3248 74.8002 98.7076ZM87.7491 99.1665C88.376 99.1665 88.9106 98.7102 89.0132 98.0903L94.5748 64.5394C94.7043 63.7609 95.5069 63.0791 96.2928 63.0791H102.709C103.495 63.0791 104.297 63.7609 104.426 64.5394L109.989 98.0916C110.092 98.7128 110.626 99.1678 111.253 99.1678H120.465L99.5005 124.231L78.5349 99.1678H87.7491V99.1665Z",
				fill: "#212120"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 200,
			fill: "white"
		})
	}) })]
});
export default SvgDownload;
